import React from 'react';
import classNames from 'classnames/bind';
import styles from './SearchSuggestions.module.scss';
import ItemSuggestions from "./ItemSuggestions/ItemSuggestions"
const cx = classNames.bind(styles);

const SearchSuggestions = ({
    isVisible,
    searchResults,
    isMobile = false // Thêm prop để phân biệt mobile/desktop
}) => {

    if (!isVisible) {
        return null;
    }

    return (
        <div className={cx('suggestions-container', {
            'suggestions-container--mobile': isMobile,
            'suggestions-container--desktop': !isMobile,
            'suggestions-container--noResult': searchResults.length < 1,

        })}>
            <div className={cx('suggestions-list', { "suggestions-noResult": searchResults.length < 1 })}>
                {searchResults.length > 0 ? searchResults.map((suggestion, index) => (
                    <ItemSuggestions key={index} item={suggestion} />
                )) : (
                    <div className={cx('noResult')}>
                        Không có kết quả tìm kiếm
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchSuggestions;